export default "__VITE_ASSET__CLZrK2X___"